"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToInputMode = exports.mapToDetailedInputMode = exports.isFocusDriven = exports.DetailedInputMode = exports.InputMode = void 0;
var InputMode;
(function (InputMode) {
    /** @member {string} */
    /** The last input was from user touch */
    InputMode["Touch"] = "Touch";
    /** @member {string} */
    /** The last input was from mouse click */
    InputMode["Mouse"] = "Mouse";
    /** @member {string} */
    /** the last input was from a gamepad */
    InputMode["Gamepad"] = "Gamepad";
    /** @member {string} */
    /** the last input was from a keyboard press */
    InputMode["Keyboard"] = "Keyboard";
})(InputMode || (exports.InputMode = InputMode = {}));
var DetailedInputMode;
(function (DetailedInputMode) {
    /** @member {string} */
    /** The last input was from user touch */
    DetailedInputMode["Touch"] = "Touch";
    /** @member {string} */
    /** The last input was from mouse click */
    DetailedInputMode["Mouse"] = "Mouse";
    /** @member {string} */
    /** the last input was from a passive mouse move event */
    DetailedInputMode["PassiveMouse"] = "PassiveMouse";
    /** @member {string} */
    /** the last input was from a gamepad */
    DetailedInputMode["Gamepad"] = "Gamepad";
    /** @member {string} */
    /** the last input was from a keyboard press */
    DetailedInputMode["Keyboard"] = "Keyboard";
})(DetailedInputMode || (exports.DetailedInputMode = DetailedInputMode = {}));
const isFocusDriven = (inputMode) => {
    return (inputMode === DetailedInputMode.Gamepad ||
        inputMode === DetailedInputMode.Keyboard ||
        inputMode === InputMode.Gamepad ||
        inputMode === InputMode.Keyboard);
};
exports.isFocusDriven = isFocusDriven;
const mapToDetailedInputMode = (inputMode) => {
    switch (inputMode) {
        case InputMode.Gamepad:
            return DetailedInputMode.Gamepad;
        case InputMode.Keyboard:
            return DetailedInputMode.Keyboard;
        case InputMode.Mouse:
            return DetailedInputMode.Mouse;
        case InputMode.Touch:
            return DetailedInputMode.Touch;
    }
};
exports.mapToDetailedInputMode = mapToDetailedInputMode;
const mapToInputMode = (inputMode) => {
    switch (inputMode) {
        case DetailedInputMode.Gamepad:
            return InputMode.Gamepad;
        case DetailedInputMode.Keyboard:
            return InputMode.Keyboard;
        case DetailedInputMode.Mouse:
        case DetailedInputMode.PassiveMouse:
            return InputMode.Mouse;
        case DetailedInputMode.Touch:
            return InputMode.Touch;
    }
};
exports.mapToInputMode = mapToInputMode;
//# sourceMappingURL=data:application/json;base64,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